import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#zi1xj1rhl__clip0_1_5418)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#ybfvm7ybp__clip1_1_5418)",
          children: [_jsx("path", {
            d: "M-5 1H25V19H-5V1Z",
            fill: "#00A551"
          }), _jsx("path", {
            d: "M-5 1H25V14.5H-5V1Z",
            fill: "#FFD500"
          }), _jsx("path", {
            d: "M-5 1H25V10H-5V1Z",
            fill: "#1A206D"
          }), _jsx("path", {
            d: "M-5 1H25V5.5H-5V1Z",
            fill: "#EA2839"
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "zi1xj1rhl__clip0_1_5418",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "ybfvm7ybp__clip1_1_5418",
          children: _jsx("rect", {
            width: "30",
            height: "18",
            fill: "white",
            transform: "translate(-5 1)"
          })
        })]
      })]
    }))
  });
};
export default Component;
